import {Skeleton, SkeletonText, VStack} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {FC} from 'react';

export const DishSkeleton: FC = () => {
  return (
    <VStack
      alignItems="stretch"
      cursor="pointer"
      bg={colors.white}
      borderRadius="16px"
      p={['12px', '15px']}
      minH={['140px', '214px']}
      w="200px"
      objectFit="cover"
    >
      <Skeleton h="180px" mb="8px" borderRadius="16px" />
      <SkeletonText skeletonHeight="20px" pb="8px" w="60%" noOfLines={1} mb="4px" />
      <SkeletonText skeletonHeight="10px" w="100%" noOfLines={1} mb="8px" />
      <SkeletonText skeletonHeight="10px" w="100%" noOfLines={1} mb="8px" />
    </VStack>
  );
};
